//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import Images from '@/scripts/libs/images'

export default {
  name: 'rb-product-tile-colors-selector',
  inject: ['dataElementId', 'getIsTileFocused', 'isPlpExclusive'],
  props: {
    colors: {
      type: Array,
      required: () => [],
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    isPlpExclusive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorVariantTabIndex() {
      return this.isTileFocused ? '0' : '-1'
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isTileFocused() {
      return this.getIsTileFocused()
    },
    dataElementIdLabel() {
      return `${this.dataElementId}-variant`
    },
    allowTouchMoveConf() {
      if (this.isPlpExclusive) {
        return this.isMobile
      }
      return true
    },
    swiperConfig() {
      return {
        observer: true,
        slidesPerView: 'auto',
        initialSlide: 0,
        spaceBetween: this.isMobile ? 0 : 2,
        allowTouchMove: this.allowTouchMoveConf,
        touchStartPreventDefault: false,
        grabCursor: false,
      }
    },
  },
  mounted() {
    if (this.colors.length > 5 && !this.isPlpExclusive) {
      const nextArrow = this.$refs?.swiper?.$el?.querySelector(
        '.swiper-button-next.swiper-button-disabled'
      )
      if (nextArrow) {
        nextArrow?.classList?.remove('swiper-button-disabled')
        nextArrow.ariaDisabled = false
      }
    }
  },
  methods: {
    actionOnSlide(index, context) {
      if (context) {
        this.$emit('update:change-variant', index)
      }
    },
    addParams(image) {
      return Images.getProductTileVariantImage({
        mediaQuery: this.$mq,
        productImage: image,
        productType: this.category,
      })
    },
  },
}
